import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import * as pdfjs from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import mammoth from "mammoth";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

type Props = {
  file: File | null;
};

const DocumentPreviewer: React.FC<Props> = ({ file }) => {
  const [thumbnail, setThumbnail] = useState<string | null>(null);

  useEffect(() => {
    if (!file) return;

    const ext = file.name.split(".").pop()?.toLowerCase();
    if (ext === "pdf") loadPdf(file);
    else if (["docx", "doc", "odt"].includes(ext || "")) loadDocx(file);
    else if (file.type.startsWith("image/")) {
      setThumbnail(URL.createObjectURL(file));
    }
  }, [file]);

  // ---------- PDF FIRST PAGE ---------- //
  const loadPdf = async (file: File) => {
    try {
      const fileUrl = URL.createObjectURL(file);

      const pdf = await pdfjs.getDocument(fileUrl).promise;
      const page = await pdf.getPage(1);

      const viewport = page.getViewport({ scale: 1 });
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d")!;

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({ canvasContext: ctx, viewport }).promise;

      const img = canvas.toDataURL("image/jpeg", 0.9);
      setThumbnail(img);
    } catch (e) {
      console.error("PDF render error", e);
    }
  };

  // ---------- DOCX / ODT PREVIEW ---------- //
  const loadDocx = async (file: File) => {
    const buffer = await file.arrayBuffer();

    const { value: html } = await mammoth.convertToHtml({ arrayBuffer: buffer });

    const div = document.createElement("div");
    div.style.position = "absolute";
    div.style.left = "-9999px";
    div.style.width = "600px";
    div.style.height="1000px"
    div.innerHTML = html;
    document.body.appendChild(div);

    const canvas = await html2canvas(div);
    const img = canvas.toDataURL("image/jpeg", 0.9);

    document.body.removeChild(div);
    setThumbnail(img);
  };

  return (
    <div style={{ marginTop: 20 }}>
      {thumbnail ? (
        <img
          src={thumbnail}
          alt=""
          style={{ height: "800px", border: "1px solid #ccc" }}
        />
      ) : (
        <div>No preview available</div>
      )}
    </div>
  );
};

export default DocumentPreviewer;
